import {SorterFiltersType} from "../hooks/useSorterQuery";
import {TFunction} from 'i18next';

export const SorterFilterInitialValue: SorterFiltersType = {
    sorterCode: undefined,
    sorterName: undefined,
    sorterStatus: undefined,
    sorterType: undefined,
    warehouseId: undefined,
    warehouseIds: undefined,
};

// 分拣机状态选项（使用函数返回以支持国际化）
export const getSorterStatusOptions = (t: TFunction) => [
    { value: '', label: t('components.input.all') },
    { value: '0', label: t('wms.sorter.status.unused') },
    { value: '1', label: t('wms.sorter.status.inUse') },
];

// 分拣机类型选项（使用函数返回以支持国际化）
export const getSorterTypeOptions = (t: TFunction) => [
    { value: '', label: t('components.input.all') },
    { value: '1', label: t('wms.sorter.type.dws') },
    { value: '2', label: t('wms.sorter.type.crossBelt') },
    { value: '3', label: t('wms.sorter.type.smallParcelScanner') },
    { value: '4', label: t('wms.sorter.type.rapidScan') },
    { value: '5', label: t('wms.sorter.type.linearSorter') },
    { value: '6', label: t('wms.sorter.type.smallTrain') },
];

